import Slider from '@/common/components/Slider/Slider';
import { testimonialsData } from '@/modules/HomePage/components/Referrals/Referrals.data';
import ReferralsSlide from '@/modules/HomePage/components/Referrals/ReferralsSlider/ReferralsSlide';
import { SimpleTrustPilot } from 'generatedBfw/static';

import styles from './Referrals.module.scss';
import ReferralsSocials from './ReferralsSocials';
import ReferralsTrustpilot from './ReferralsTrustpilot';

interface ReferralsProps {
  trustPilot: SimpleTrustPilot;
}

const Referrals = ({ trustPilot }: ReferralsProps) => {
  return (
    <section className={styles.container} data-testid="referrals-section">
      <h2 className={styles.title}>
        Other people love our <br className={styles.breakLineDesktop} /> metal collectibles
      </h2>
      <ReferralsTrustpilot trustPilot={trustPilot} />
      <span className={styles.subtitle}>{trustPilot.aggregatedScoreName}</span>
      <ReferralsSocials />
      <Slider
        keyExtractor={({ id }) => id}
        metadata={{ elementVariant: 'testimonials' }}
        renderSlide={(testimonial) => <ReferralsSlide testimonial={testimonial} />}
        slides={testimonialsData}
      />
    </section>
  );
};

export default Referrals;
